import { ONBOARDING_TRANSITION_DURATION_MS } from "@/features/user-profile/constants/onboarding-transition";
import { delay } from "@/features/user-profile/utils/delay";
import { useGetGoals } from "@/hooks/requests/goals/use-get-goals";
import { useUpdateGoals } from "@/hooks/requests/goals/use-update-goals";
import { useToast } from "@/hooks/ui/use-toast";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonContent, IonPage } from "@ionic/react";
import { useState } from "react";
import { OnboardingStepShell } from "../../components/onboarding-step-shell";
import { SelectablePill } from "../../components/selectable-pill";

const GOAL_OPTIONS = [
  { id: "weight-loss", label: "Weight loss" },
  { id: "weight-maintain", label: "Maintaining my weight" },
  { id: "weight-gain", label: "Weight gain" },
];

const OnboardingGoalPage = () => {
  const { navigateToNextStep, preloadNextRoute } = useStepRouteInfo();
  const { goals } = useGetGoals();
  const { updateGoalsAsync, isUpdating } = useUpdateGoals();
  const { showError } = useToast();
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const handleSelect = async (specificWeightGoals: string) => {
    if (isUpdating) return;
    setSelectedId(specificWeightGoals);
    await delay(ONBOARDING_TRANSITION_DURATION_MS);
    try {
      await Promise.all([
        preloadNextRoute(),
        updateGoalsAsync({
          specificWeightGoals,
          goalsWithNutriCoach: goals?.goalsWithNutriCoach ?? "",
        }),
      ]);
      navigateToNextStep();
    } catch (error) {
      showError(error instanceof Error ? error.message : "An unexpected error occurred");
    }
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        <OnboardingStepShell
          icon="/assets/images/onboarding-icons/goal.svg"
          title="What are we working towards?"
          subtitle="Your NutriCoach will adapt around this"
        >
          <div className="flex w-full flex-col items-center gap-6">
            {GOAL_OPTIONS.map((option) => (
              <SelectablePill
                key={option.id}
                label={option.label}
                variant={selectedId === option.id ? "active" : "default"}
                onClick={() => handleSelect(option.id)}
                disabled={isUpdating}
              />
            ))}
          </div>
        </OnboardingStepShell>
      </IonContent>
    </IonPage>
  );
};

export default OnboardingGoalPage;
